import { motion } from 'framer-motion';

const companies = [
  {
    logo: 'https://static.readdy.ai/image/76bdc5cf9f6b144760a23d447c3fb67d/ba3686ec65373aa28b7c02a6bd2618ee.png',
    name: 'Sudaca',
    category: 'Agencia de marketing',
    text: '"Necesitábamos resolver temas legales de forma rápida para nuestros proyectos. El proceso fue claro, ágil y sin complicaciones."',
  },
  {
    logo: 'https://static.readdy.ai/image/76bdc5cf9f6b144760a23d447c3fb67d/f2476e2e5f376b062afc41bf5269d1cf.jpeg',
    name: 'Still Pool',
    category: 'Productora audiovisual',
    text: '"Trabajamos con Bala Corp en temas contractuales y fue todo muy ordenado y eficiente. Destaca la rapidez y claridad en el proceso."',
  },
  {
    logo: 'https://static.readdy.ai/image/76bdc5cf9f6b144760a23d447c3fb67d/2eed85c8f6f80bdc6a935d676b9ff704.jpeg',
    name: 'CNMG Service',
    category: 'Servicios empresariales',
    text: '"Nos ayudaron a resolver trámites legales que normalmente toman mucho tiempo. La gestión fue directa y sin fricciones."',
  },
];

const TestimonialsSection = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gray-100"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div>
              <p className="text-xs font-bold tracking-widest text-gray-400 uppercase mb-4">
                Prueba social
              </p>
              <h2 className="text-4xl lg:text-5xl font-bold text-black leading-tight">
                Empresas que han trabajado
                <br />
                <span className="text-black">con nosotros</span>
              </h2>
            </div>
            {/* Logos strip */}
            <div className="flex items-center gap-8">
              {companies.map((c, i) => (
                <div key={i} className="flex items-center justify-center opacity-40 hover:opacity-70 transition-opacity">
                  <div className="w-20 h-10 flex items-center justify-center">
                    <img
                      src={c.logo}
                      alt={c.name}
                      className="w-full h-full object-contain grayscale"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-10 w-full h-px bg-gray-100"></div>
        </motion.div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {companies.map((company, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.12, duration: 0.6 }}
              className="group border border-gray-100 rounded-2xl p-8 hover:border-primary-yellow transition-all duration-300 cursor-default flex flex-col justify-between bg-white"
            >
              {/* Quote icon */}
              <div className="mb-6">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-double-quotes-l text-2xl text-primary-yellow"></i>
                </div>
              </div>

              {/* Testimonial text */}
              <p className="text-gray-700 text-base leading-relaxed mb-8 flex-1">
                {company.text}
              </p>

              {/* Company info */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                <div className="w-11 h-11 flex items-center justify-center flex-shrink-0 bg-gray-50 rounded-xl overflow-hidden">
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="w-full h-full object-contain p-1"
                  />
                </div>
                <div>
                  <p className="text-sm font-bold text-black">{company.name}</p>
                  <p className="text-xs text-gray-400">{company.category}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom trust line */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="mt-14 flex items-center justify-center gap-3 text-sm text-gray-400"
        >
          <i className="ri-shield-check-line text-primary-yellow text-base"></i>
          <span>Clientes reales que confiaron en Bala Corp para sus trámites legales</span>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
